import { useaxios } from "../../../utils/useaxios";
export default (mizania_date) => initDispatch => clear => {
    // initDispatch({ type: 'loadingTrue' });
    useaxios('report/mizania/company_list.php', { mizania_date }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        } else if (res.status == "ok") {
            initDispatch({ type: 'setmizania_form_ddata', payload: res?.data });
            initDispatch({ type: 'setmizania_form_table_type', payload: "company_loan_report" });
        }
    });
}